// extracted by mini-css-extract-plugin
export default {"LeadershipCard":"LeadershipCard_LeadershipCard__ofRNj","LeaderName":"LeadershipCard_LeaderName__eU+-l","leaderPosition":"LeadershipCard_leaderPosition__cV61S"};